import React, {ReactNode} from 'react';

import {Period} from '@/widgets/Period';
import {Title} from '@shared/ui/Title';

import {Wrapper} from './styled';

interface PageHeaderProps {
    title: string;
    children?: ReactNode;
}

export const PageHeader = ({title, children}: PageHeaderProps) => (
    <Wrapper>
        <Title size={2}>{title}</Title>
        {children ?? <Period />}
    </Wrapper>
);
